import React from 'react';
import { modals, tags } from "../../ducks";
import duckify from "../../utils/duckify";
import PageHeader from "../PageHeader";
import ContactList from "../ContactList/ContactList";
import { formatDateTime } from "../../utils";
import FALabel from "../shared/FALabel";
import LinkButton from "../LinkButton/LinkButton";
import ModalRoot from "../ModalRoot";
import EditTagModal from "./EditTagModal";
import DeleteTagModal from "./DeleteTagModal";
import './styles/TagListPage.scss';

const TagListPage = ({ tags, onEditTag, onDeleteTag }) => {
  const columns = [
    {
      header: 'Tag Name',
      value: tag => <td>{tag.name}</td>,
    },
    {
      header: 'Last Edited',
      value: tag => <td>
        {formatDateTime(tag.updated_at, 'fns_date') + (tag.updated_by ? ` by ${tag.updated_by}` : '')}
      </td>
    },
    {
      header: '',
      value: tag =>
        <td>
          <LinkButton onClick={() => onEditTag(tag)} content="Edit" />{' '}|
          <LinkButton onClick={() => onDeleteTag(tag)} content="Delete" />
        </td>
    }
  ];

  return <React.Fragment>
    <PageHeader header="Tags" />

    <LinkButton
      className="add-item-button tag-list-add"
      content={<FALabel icon="plus-circle" iconFirst label="Add a new Tag" />}
      onClick={onEditTag}
    />

    <ContactList
      className="table-hover tag-list-table"
      columns={columns}
      contacts={tags}
      emptyMessage="No tags"
    />

    <ModalRoot modals={{ EditTagModal, DeleteTagModal }} />
  </React.Fragment>;
};

const mapDucksToProps = () => ({
  tags
});

const mapDispatchToProps = (dispatch) => ({
  onEditTag: tag => dispatch(modals.actions.show('EditTagModal', { tag })),
  onDeleteTag: tag => dispatch(modals.actions.show('DeleteTagModal', { tag })),
});

export default duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(TagListPage);
